export const CSS_CLASSES = {
	CELL_PROPOSED: 'data-table__cell--proposed',
	CELL_ACTIVE: 'data-table__cell--active',
	CELL_RESOLVED: 'data-table__cell--resolved',
	CELL_CLOSED: 'data-table__cell--closed',
	DIV_SEC_EMAIL: 'div--secondary-email',
};
